import { Injectable, Type } from '@angular/core';
import { OrderTypeEnum } from '@core/enums';
import { StoreDeliveryCodeEnum } from '../enums';
import { IStoresListStrategyDomain } from '../interfaces';
import { PickupStrategyComponent, DeliveryStrategyComponent } from '../components/strategies';

@Injectable({ providedIn: 'root' })
export class StoresListFactory {
	private strategies = new Map<string, Type<IStoresListStrategyDomain>>([
		[OrderTypeEnum.Pickup, PickupStrategyComponent],
		[OrderTypeEnum.Delivery, DeliveryStrategyComponent],
		[StoreDeliveryCodeEnum.Pickup, PickupStrategyComponent],
		[StoreDeliveryCodeEnum.Delivery, DeliveryStrategyComponent],
	]);

	getStrategy(type: string | OrderTypeEnum | StoreDeliveryCodeEnum): Type<IStoresListStrategyDomain> | null {
		const strategy = this.strategies.get(type);
		if (!strategy) {
			console.error(`[StoresListFactory] No existe estrategia para el tipo: ${type}`);
			return this.strategies.get(OrderTypeEnum.Pickup) ?? null;
		}
		return strategy;
	}
}
